export const COMPANY = {
  name: "KS Infinity Export",
  short: "KS Infinity",
  tagline: "Packaging that breathes.",
  email: "info@ksinfinityexport.com",
  contacts: [
    { name: "Abhinav", phone: "+91 70116 29595", raw: "917011629595" },
    { name: "Ansh", phone: "+91 80063 57736", raw: "918006357736" },
  ],
  location: "India",
};

export const PRODUCTS = [
  {
    slug: "paper-bags",
    name: "Paper Bags",
    tag: "Retail & Boutique",
    description:
      "Craft-forward paper bags engineered for weight, printed with soy-based inks, and stitched for the shelf life your brand deserves.",
    highlights: ["Craft & white variants", "Custom printing", "Twisted & flat handles"],
    image: "/paperbags/paperbag-01.jpg",
  },
  {
    slug: "paper-plates",
    name: "Paper Plates",
    tag: "Foodservice",
    description:
      "Sturdy, food-safe paper plates in dessert (7.5\") and dinner (9.5\") sizes — with printed and gold-foil designs for festivals, catering and everyday hospitality.",
    highlights: ["7.5\" dessert & 9.5\" dinner", "Grease resistant", "Compostable"],
    image: "/plates/pp-01.jpg",
  },
  {
    slug: "gift-wrap-rolls",
    name: "Gift Wrap Rolls",
    tag: "Seasonal & Gifting",
    description:
      "Decorative wrap rolls, printed in-house with fade-resistant pigments. Suited for stationers, hampers and premium retail.",
    highlights: ["Matte & metallic finishes", "Custom pattern MOQ", "OEM-ready"],
    image: "/giftwrap/giftwrap-01.jpg",
  },
  {
    slug: "disposable-glass",
    name: "Disposable Glass",
    tag: "Beverage",
    description:
      "Single-use paper cups & glasses lined for hot and cold service — from chai stalls to airline catering.",
    highlights: ["350ml", "PE / PLA lining", "Custom print"],
    image: "/glass/glass-01.jpg",
  },
];
